import React from 'react';

/**
 * Router for pages.
 * @author James Adams
 * @param {object} props
 * @returns {jsx}
 * @public
 */
 function Content(props){
   const component = props.pages[props.page];
   const state = props.state[props.page];
   return (
     <div className="content">
     {_router(props, component, state)}
     </div>
   );
 }


 /**
  * Routes the incoming request to the page that it matches up with.
  * @param {object} props of the page to be rendered.
  * @param {object} component for the individual -apage
  * @param {object} state for the individual page.
  * @returns {jsx}
  * @private
  */
function _router(props, component, state){
  const id = props.page;
  let CC = null;
  let features = {};

  if(component){
    CC = component;
  }else{
    throw new Error('Unrecognized page '+id);
  }

  if(state=== undefined){
    console.warn('Could not resolve state for '+id);
  }

  if(props.acl){
    features = props.acl.features();
  }

  if(CC){
    return(
      <CC
        stateName={id}
        item={props.item}
        state={state}
        getState={props.getState}
        updateState={props.updateState}
        resetState={props.resetState}
        resetMultiple={props.resetMultipleState}
        acl={props.acl}
        features={features}
      />
    );
  }
}

export default Content;
